'use client';

import React from 'react';
import { Wrapper, WrapperButton, WrapperDropdown, WrapperInput } from "./index.styled.mjs";
/**
 * Allows a [Dropdown](https://sites.spotify.net/spa/@spotify-internal-encore-web/?path=/docs/components-dropdown) to be placed next to an input. Use to apply filters to an input or when a selection is tightly
 * coupled to an input value.
 */
export var FormInputDropdown = function FormInputDropdown(_ref) {
  var dropdownLeft = _ref.dropdownLeft,
    dropdownRight = _ref.dropdownRight,
    button = _ref.button,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Wrapper, null, dropdownLeft && /*#__PURE__*/React.createElement(WrapperDropdown, {
    radiusLeft: true
  }, dropdownLeft), /*#__PURE__*/React.createElement(WrapperInput, {
    radiusLeft: !dropdownLeft,
    radiusRight: !dropdownRight
  }, children), dropdownRight && /*#__PURE__*/React.createElement(WrapperDropdown, {
    radiusRight: true
  }, dropdownRight), button && /*#__PURE__*/React.createElement(WrapperButton, null, button));
};